export default __webpack_public_path__ + "static/supportHero-5b3063f0c410d904cbf88f22e1d1a6a4.png";